import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Container, Title, Icon} from './styles';

const Card = ({icon, title, description, children}) => (
  <Container className="card shadow p-3 bg-white rounded">
    <Icon>
      <FontAwesomeIcon icon={icon} size="4x" />
    </Icon>
    <div className="card-body">
      <Title>
        {title}
      </Title>
      <p className="card-text">
        {description}
      </p>
    </div>
    <div className="card-footer text-center">
      {children}
    </div>
  </Container>
);

export default Card;